import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon", "menu", "toggle"]

  toggle(event) {
    const index = [...this.toggleTargets].indexOf(event.currentTarget)

    if (index > -1) {
      if (this.lastIndex != null) {
        this.iconTargets[this.lastIndex].classList.remove("rotate-90")
        this.menuTargets[this.lastIndex].classList.add("hidden")
      }

      if (index !== this.lastIndex) {
        this.iconTargets[index].classList.add("rotate-90")
        this.menuTargets[index].classList.remove("hidden")
        this.lastIndex = index
      } else {
        this.lastIndex = undefined
      }
    }
  }
}
